module.exports = __webpack_public_path__ + "static/img/zgdelete.624f768.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zgdelete.png
// module id = eto8
// module chunks = 3